module.exports = __webpack_public_path__ + "img/logo.86b2ff19.svg";